import { MapPin, Check } from 'lucide-react';

// Formats a large integer with thin space separators (12 345).
const fmt = (n) => (n == null ? '—' : Number(n).toLocaleString('fr-FR'));

// One row of the scope grouped list — a city cluster inside the current radius.
export const CityGroupRow = ({ group, isSelected, onToggle }) => {
  const {
    city,
    nice_distance_km,
    total,
    already_imported,
    by_source = {},
    avg_price,
  } = group;

  const remaining = Math.max(0, (total || 0) - (already_imported || 0));

  return (
    <li data-testid={`scope-city-group-row-${String(city).toLowerCase().replace(/\s+/g, '-')}`}>
      <button
        type="button"
        onClick={() => onToggle(city)}
        aria-pressed={isSelected}
        className={
          'flex items-center gap-3 w-full text-left px-3 py-2 rounded border transition-all cursor-pointer ' +
          (isSelected
            ? 'border-purpleColor bg-purpleColor/5'
            : 'border-gray-200 hover:border-purpleColor hover:shadow-sm')
        }
      >
      <span
        className={
          'flex items-center justify-center w-5 h-5 rounded border ' +
          (isSelected
            ? 'bg-purpleColor border-purpleColor text-white'
            : 'border-gray-300 bg-white')
        }
      >
        {isSelected && <Check size={14} />}
      </span>

      <div className="flex-1 min-w-0">
        <div className="flex items-baseline gap-2">
          <span className="text-sm font-medium text-blackColor truncate">
            {city}
          </span>
          <span className="flex items-center gap-1 text-xs text-darkGrayColor">
            <MapPin size={12} />
            {nice_distance_km != null
              ? `${Number(nice_distance_km).toFixed(1)} km`
              : '—'}
          </span>
        </div>

        <div className="flex items-center gap-3 mt-1 text-xs text-darkGrayColor">
          <span className="font-semibold text-blackColor">{fmt(total)}</span>
          <span>records</span>
          {already_imported > 0 && (
            <span className="px-1.5 py-0.5 rounded bg-lightYellowColor text-yellowColor font-medium">
              {fmt(already_imported)} imported
            </span>
          )}
          {remaining > 0 && (
            <span className="px-1.5 py-0.5 rounded bg-greenColor/10 text-greenColor font-medium">
              +{fmt(remaining)} new
            </span>
          )}
          {avg_price != null && (
            <span className="text-darkGrayColor">
              avg{' '}
              <span className="font-medium text-blackColor">
                {fmt(Math.round(avg_price))} €
              </span>
            </span>
          )}
        </div>
      </div>

      <div className="hidden md:flex items-center gap-1 flex-wrap max-w-[240px]">
        {Object.entries(by_source).map(([src, count]) => (
          <span
            key={src}
            className="px-1.5 py-0.5 text-[10px] rounded bg-lightGrayColor text-darkGrayColor whitespace-nowrap"
            title={`${src}: ${count}`}
          >
            {src.replace(/_spider$/, '')} · {fmt(count)}
          </span>
        ))}
      </div>
      </button>
    </li>
  );
};
